(function(){
  var header=document.querySelector('[data-site-header]');
  var button=document.querySelector('[data-menu-button]');
  var drawer=document.querySelector('[data-mobile-drawer]');
  function onScroll(){if(header)header.classList.toggle('is-stuck',window.scrollY>24)}
  onScroll();window.addEventListener('scroll',onScroll,{passive:true});
  function setMenu(open){
    if(!button||!drawer)return;
    drawer.classList.toggle('open',open);
    button.setAttribute('aria-expanded',String(open));
    button.setAttribute('aria-label',open?'Close menu':'Open menu');
    document.body.style.overflow=open?'hidden':'';
  }
  if(button)button.addEventListener('click',function(){setMenu(!drawer.classList.contains('open'))});
  if(drawer)drawer.addEventListener('click',function(e){if(e.target.closest('a'))setMenu(false)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')setMenu(false)});
  var reveals=[].slice.call(document.querySelectorAll('.reveal'));
  function showAll(){reveals.forEach(function(el){el.classList.add('in')})}
  if('IntersectionObserver'in window){
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('in');observer.unobserve(entry.target)}})},{threshold:.08,rootMargin:'0px 0px -50px'});
    reveals.forEach(function(el){observer.observe(el)});setTimeout(showAll,2400);
  }else{showAll()}
})();
// Native details provide keyboard and touch access to category dropdowns.
(() => {
  const dropdowns = [...document.querySelectorAll('[data-nav-dropdown]')];
  const closeDropdown = (dropdown) => {
    dropdown.open = false;
    dropdown.querySelectorAll('details[open]').forEach((nested) => { nested.open = false; });
  };
  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (dropdown.open) dropdowns.forEach((other) => { if (other !== dropdown) closeDropdown(other); });
    });
    dropdown.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !dropdown.contains(event.relatedTarget)) closeDropdown(dropdown);
    });
  });
  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => { if (!dropdown.contains(event.target)) closeDropdown(dropdown); });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement.closest('[data-nav-dropdown]');
    if (active?.open) active.querySelector('summary')?.focus();
    dropdowns.forEach(closeDropdown);
  });
  window.matchMedia('(max-width:1180px)').addEventListener('change', () => {
    dropdowns.forEach(closeDropdown);
    const menuButton = document.querySelector('[data-menu-button]');
    if (menuButton?.getAttribute('aria-expanded') === 'true') menuButton.click();
  });
})();
document.querySelectorAll('.product-thumb').forEach((button) => {
  button.addEventListener('click', () => {
    const mainImage = document.querySelector('[data-product-main-image], .product-main-media img');
    const thumbnailImage = button.querySelector('img');
    if (!mainImage || !thumbnailImage) return;
    mainImage.src = button.dataset.imageSrc || thumbnailImage.src;
    mainImage.alt = button.dataset.imageAlt || thumbnailImage.alt;
    document.querySelectorAll('.product-thumb').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
  });
});

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
        })
        .catch(() => {});
    }
  });
}
/* Luna commerce interactions */
(() => {
  const rootPath = window.Shopify?.routes?.root || '/';
  const setOpenState = (element, open) => {
    if (!element) return;
    element.classList.toggle('open', open);
    element.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-open]')) { const overlay = document.querySelector('[data-search-overlay]'); setOpenState(overlay, true); overlay?.querySelector('input[type=search]')?.focus(); }
    if (event.target.closest('[data-search-close]')) setOpenState(document.querySelector('[data-search-overlay]'), false);
    if (event.target.closest('[data-cart-open]')) { const drawer = document.querySelector('[data-cart-drawer]'); setOpenState(drawer, true); drawer?.querySelector('[data-cart-close]')?.focus(); }
    if (event.target.closest('[data-cart-close]')) setOpenState(document.querySelector('[data-cart-drawer]'), false);
    if (event.target.closest('[data-filter-toggle]')) document.querySelector('[data-filter-panel]')?.classList.toggle('open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    setOpenState(document.querySelector('[data-search-overlay]'), false);
    setOpenState(document.querySelector('[data-cart-drawer]'), false);
  });

  document.querySelectorAll('[data-auto-submit]').forEach((control) => {
    control.addEventListener('change', () => control.form?.submit());
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const section = select.closest('[data-product-section]');
      const available = option.dataset.available === 'true';
      const price = section?.querySelector('[data-product-price]');
      const comparePrice = section?.querySelector('[data-product-compare-price]');
      const status = section?.querySelector('[data-product-availability]');
      const submit = section?.querySelector('[data-product-submit]');
      const submitText = section?.querySelector('[data-product-submit-text]');
      const mainImage = section?.querySelector('.product-main-media img');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }
      if (status) status.textContent = available ? 'Available' : 'Sold';
      if (submit) submit.disabled = !available;
      if (submitText) submitText.textContent = available ? 'Add to Cart' : 'Sold';
      if (mainImage && option.dataset.image) {
        mainImage.src = option.dataset.image;
        mainImage.alt = option.dataset.imageAlt || mainImage.alt;
      }
      if (option.dataset.url) history.replaceState({}, '', option.dataset.url);
    });
  });

  let predictiveTimer;
  const predictiveInput = document.querySelector('[data-predictive-search-input]');
  const predictiveResults = document.querySelector('[data-predictive-results]');
  predictiveInput?.addEventListener('input', () => {
    clearTimeout(predictiveTimer);
    const query = predictiveInput.value.trim();
    if (query.length < 2) {
      if (predictiveResults) predictiveResults.innerHTML = '';
      return;
    }
    predictiveTimer = setTimeout(async () => {
      try {
        const endpoint = predictiveInput.dataset.predictiveUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,vendor,product_type&resources[options][unavailable_products]=hide&section_id=predictive-search';
        const response = await fetch(endpoint);
        const responseText = await response.text();
        const documentFragment = new DOMParser().parseFromString(responseText, 'text/html');
        const content = documentFragment.querySelector('[data-predictive-content]');
        if (predictiveResults) predictiveResults.innerHTML = content?.innerHTML || '';
      } catch (error) {
        if (predictiveResults) predictiveResults.innerHTML = '';
      }
    }, 220);
  });

  const refreshCartDrawer = async () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const sectionId = drawer?.dataset.sectionId || 'cart-drawer';
    const response = await fetch(rootPath + '?section_id=' + encodeURIComponent(sectionId));
    const responseText = await response.text();
    const parsed = new DOMParser().parseFromString(responseText, 'text/html');
    const replacement = parsed.querySelector('[data-cart-drawer]');
    if (drawer && replacement) drawer.replaceWith(replacement);
    const updatedDrawer = document.querySelector('[data-cart-drawer]');
    const itemCount = Number(updatedDrawer?.dataset.cartItemCount || 0);
    const cartButton = document.querySelector('[data-cart-open]');
    let countBadge = document.querySelector('[data-cart-count]');
    if (itemCount > 0) {
      if (!countBadge && cartButton) {
        countBadge = document.createElement('span');
        countBadge.className = 'cart-count';
        countBadge.dataset.cartCount = '';
        cartButton.appendChild(countBadge);
      }
      if (countBadge) countBadge.textContent = itemCount;
    } else {
      countBadge?.remove();
    }
    setOpenState(updatedDrawer, true);
  };

  document.querySelectorAll('[data-product-section] form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[data-product-submit]');
      if (submit?.disabled) return;
      submit?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Unable to add item');
        await refreshCartDrawer();
      } catch (error) {
        window.location.href = rootPath + 'cart';
      } finally {
        submit?.removeAttribute('aria-busy');
      }
    });
  });
})();

/* Product image lightbox: click the main product photo to view every image full screen */
(() => {
  const box = document.querySelector('[data-lightbox]');
  const trigger = document.querySelector('[data-lightbox-open]');
  if (!box || !trigger) return;
  const sources = [...box.querySelectorAll('[data-lightbox-src]')];
  const img = box.querySelector('[data-lightbox-image]');
  const count = box.querySelector('[data-lightbox-count]');
  let index = 0;
  let lastFocus = null;
  const path = (url) => (url || '').split('?')[0].replace(/^https?:/, '').replace(/_\d+x\d*(?=\.)/, '');
  const show = (i) => {
    if (!sources.length) return;
    index = (i + sources.length) % sources.length;
    img.src = sources[index].dataset.lightboxSrc;
    img.alt = sources[index].dataset.lightboxAlt || '';
    if (count) count.textContent = sources.length > 1 ? (index + 1) + ' / ' + sources.length : '';
  };
  const currentIndex = () => {
    const thumbs = [...document.querySelectorAll('.product-thumb')];
    const active = thumbs.findIndex((t) => t.classList.contains('is-active'));
    const main = trigger.querySelector('img');
    if (main) {
      const mainPath = path(main.currentSrc || main.src);
      const hit = sources.findIndex((s) => path(s.dataset.lightboxMatch) === mainPath || path(s.dataset.lightboxSrc) === mainPath);
      if (hit > -1) return hit;
    }
    return active > -1 ? active : 0;
  };
  const open = () => {
    lastFocus = document.activeElement;
    show(currentIndex());
    box.hidden = false;
    requestAnimationFrame(() => box.classList.add('open'));
    document.body.style.overflow = 'hidden';
    box.querySelector('[data-lightbox-close]').focus();
  };
  const close = () => {
    box.classList.remove('open');
    box.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };
  trigger.addEventListener('click', open);
  box.addEventListener('click', (e) => {
    if (e.target.closest('[data-lightbox-close]')) return close();
    if (e.target.closest('[data-lightbox-prev]')) return show(index - 1);
    if (e.target.closest('[data-lightbox-next]')) return show(index + 1);
    if (e.target === box || e.target.classList.contains('product-lightbox__stage')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (box.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(index - 1);
    else if (e.key === 'ArrowRight') show(index + 1);
    else if (e.key === 'Tab') {
      const items = [...box.querySelectorAll('button')];
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  let startX = null;
  box.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
  box.addEventListener('touchend', (e) => {
    if (startX === null) return;
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 45) show(index + (dx < 0 ? 1 : -1));
    startX = null;
  });
})();
